<template>
<div class="dropdown mb-2" :class="[dropdown && 'activeItem']">
    <div class="dropdown-header" @click="toggleDropdown()">
        {{ title }}
        <img src="@/assets/helpers/circle-chevron-down-solid.svg" alt="" class="dropdown-icon" :class="[dropdown && 'active']">
    </div>
    <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
        <div class="dropdown-wrapper" v-if="dropdown">
            <!-- <div id="myTabContentHijo" v-if="component=='Bme'">
                <Bme></Bme>
            </div> -->
            <div id="myTabContentHijo" v-if="component=='Evolucionmedica'">
                <Emedica :medical_act_id="medical_act_id" :addEv="addEv" @mtdaddevexit="mtdaddevexit" :dete_out="dete_out" :rolname="rolname" :dete_out_doctor="dete_out_doctor" :rol_id="rol_id"></Emedica>
            </div>
            <div id="myTabContentHijo" v-if="component=='Hchospitalizacion'">
                <Hchospitalizacion :metodoadd="metodoadd" @mtdaddexit="mtdaddexit" @changePage="changePage" :viewMedico="viewMedico" :Clinicahistory="Clinicahistory" :datapatients="datapatients" :showHistory="showHistory"></Hchospitalizacion>
            </div>
            <!-- <div id="myTabContentHijo" v-if="component=='Hojagrafica'">
                <Hojagrafica></Hojagrafica>
            </div> -->
            <div id="myTabContentHijo" v-if="component=='Notaenfermeria'">
                <Notaenfermeria :medical_act_id="medical_act_id"  :dete_out="dete_out"></Notaenfermeria>
            </div>
            <div id="myTabContentHijo" v-if="component=='Kardex'">
                <Kardex></Kardex>
            </div>
            <!-- <div id="myTabContentHijo" v-if="component=='Oxigeno'">
                <Oxigeno></Oxigeno>
            </div> -->
            <div id="myTabContentHijo" v-if="component=='Mhemodinamico'">
                <Mhemodinamico></Mhemodinamico>
            </div>
            <div id="myTabContentHijo" v-if="component=='Rp'">
                <Rp :medical_act_id="medical_act_id" :addRp="addRp" @mtdaddrpexit="mtdaddrpexit" :dete_out="dete_out" :rolname="rolname"  :dete_out_doctor="dete_out_doctor" :rol_id="rol_id"></Rp>
            </div>
        </div>
    </transition>

</div>
</template>

<script>
import Bme from '@/components/Emergencia/Emergency/Historia/Bme.vue';
import Emedica from '@/components/Emergencia/Emergency/Historia/Emedica.vue';
import Hchospitalizacion from '@/components/Emergencia/Emergency/Historia/HchospitalizacionMobile.vue';
import Hojagrafica from '@/components/Emergencia/Emergency/Historia/Hojagrafica.vue';
import Notaenfermeria from '@/components/Emergencia/Emergency/Historia/Notaenfermeria.vue'
import Kardex from '@/components/Emergencia/Emergency/Historia/Kardex.vue'
import Oxigeno from '@/components/Emergencia/Emergency/Historia/Oxigeno.vue'
import Mhemodinamico from '@/components/Emergencia/Emergency/Historia/Mhemodinamico.vue'
import Rp from '@/components/Emergencia/Emergency/Historia/Rp.vue'
export default {
    name: 'dropdown-component-hospitalizacion',
    props: {
        title: String,
        component: String,
        viewMedico: Number,
        datapatients: {
            type: Object,
            default: () => ({})
        },
        Clinicahistory: {
            type: Object,
            default: () => ({})
        },
        metodoadd: {
            type: Number,
            default: 0
        },
        showHistory: {
            type: Boolean,
            default: false
        },
        medical_act_id: {
            type: Number,
            default: 0
        },
        addEv: {
            type: Number,
            default: 0
        },
        addRp: {
            type: Number,
            default: 0
        },
        dete_out: {
            type: Boolean
        },
        dete_out_doctor: {
            type: Boolean
        },
        rolname: String,
        rol_id: Number
    },
    components: {
        Hchospitalizacion,
        Emedica,
        Rp,
        Hojagrafica,
        Notaenfermeria,
        Kardex,
        Oxigeno,
        Bme,
        Mhemodinamico

    },
    data: () => ({
        dropdown: false
    }),
    methods: {
        toggleDropdown() {
            this.dropdown = !this.dropdown;
        },
        beforeEnter(el) {
            el.style.height = 0
        },
        enter(el) {
            el.style.height = el.scrollHeight + 'px'
        },
        beforeLeave(el) {
            el.style.height = el.scrollHeight + 'px'
        },
        leave(el) {
            el.style.height = 0
        },
        mtdaddexit:function(num, payload){
            this.$emit('mtdaddexit',num, payload)
        },
        mtdaddevexit:function(){
            this.$emit('mtdaddevexit')
        },
        mtdaddrpexit:function(){
            this.$emit('mtdaddrpexit')
        }
    }
}
</script>
